<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>search</mat-icon>
        <h1>{{'予約状況：検索条件' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="search()">
          <mat-icon>search</mat-icon>
          <span>{{'検索' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content [formGroup]="editForm">
    <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">
      <mat-form-field floatLabel="always">
        <mat-label>{{'属性' | translate}}</mat-label>
        <mat-select placeholder="{{'属性' | translate}}" formControlName="facility_attribute_id" (selectionChange)="reservation_no.setValue('')">
          <mat-option [value]=""></mat-option>
          <mat-option *ngFor="let reservationFacilityAttribute of reservationFacilityAttributes" [value]="reservationFacilityAttribute.attribute_id">
            {{ reservationFacilityAttribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
          </mat-option>
            </mat-select>select-reservation-dialog.component
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label>{{'予約施設ID' | translate}}</mat-label>
        <input matInput placeholder="{{'予約施設ID' | translate}}" formControlName="facility_id">
        <button mat-button matSuffix  aria-label="Search" (click)="openSelectReservationFacilitiesDialog()">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label>{{'利用日' | translate}}：{{'開始' | translate}} - {{'終了日' | translate}}</mat-label>
        <mat-date-range-input [rangePicker]="pickerEvent">
          <input matStartDate formControlName="start_date" placeholder="{{'開始日' | translate}}" readonly (dateChange)="reservation_no.setValue('')">
          <input matEndDate formControlName="end_date" placeholder="{{'終了日' | translate}}" readonly (dateChange)="reservation_no.setValue('')">
        </mat-date-range-input>
        <button mat-button matSuffix aria-label="Clear" (click)="clearDate()">
          <mat-icon>close</mat-icon>
        </button>
        <mat-datepicker-toggle matSuffix [for]="pickerEvent"></mat-datepicker-toggle>
        <mat-date-range-picker #pickerEvent></mat-date-range-picker>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label>{{'予約状況' | translate}}</mat-label>
        <mat-select placeholder="{{'予約状況' | translate}}" formControlName="status" (selectionChange)="reservation_no.setValue('')">
          <mat-option [value]="0"></mat-option>
          <mat-option *ngFor="let status of statuses" [value]="status">
            {{status | reservationStatus}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label>{{'予約番号' | translate}}</mat-label>
        <input matInput placeholder="{{'予約番号' | translate}}" formControlName="reservation_no" (change)="facility_attribute_id.setValue(''); facility_id.setValue(''); clearDate(); status.setValue(0);">
      </mat-form-field>
    </div>
  </div>
</div>

